/* import __COLOCATED_TEMPLATE__ from './link.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */
import templateOnlyComponent from '@ember/component/template-only';

interface PostPurchaseEmptyStateLinkSignature {
  Args: {
    suiteRoute: string;
    standaloneRoute?: string;
    translationKey: string;
  };
  Element: HTMLAnchorElement;
}

const PostPurchaseEmptyStateLink = templateOnlyComponent<PostPurchaseEmptyStateLinkSignature>();
export default PostPurchaseEmptyStateLink;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::PostPurchaseEmptyState::Link': typeof PostPurchaseEmptyStateLink;
  }
}
